module.exports = __webpack_public_path__ + "img/logo0.e46a2586.png";